import React from 'react'
import { Route, Redirect } from 'react-router-dom'

import utils from '../utils/utils'
import { AuthContext } from '@/modules/auth/auth-provider'
import {
  buildLoginPath,
  getFullReturnPath,
} from '@/modules/auth/utils/auth-return'
import { canAccessProtectedRoute } from '@/modules/auth/services/auth-redirect'

/**
 * This component cant be accessed by the user if he istn logged
 * This returns a redirection to the lobby
 */
const PrivateRoute = ({ gameType, component: Component, ...rest }) => {
  return (
    <AuthContext.Consumer>
      {(auth) => (
        <Route
          {...rest}
          render={(props) => {
            if (
              utils.getReferer() === null ||
              utils.getReferer() === undefined ||
              utils.getReferer() === 'undefined'
            ) {
              const search = props.location.search

              if (search !== undefined || search !== null || search !== 'undefined') {
                const params = new URLSearchParams(search)
                utils.setReferer(params.get('referer'))
              }
            }

            if (canAccessProtectedRoute(auth)) {
              const userInfo = utils.getUserInfo()

              if (userInfo && !utils.isVerified(userInfo)) {
                return (
                  <Redirect
                    to={{
                      pathname: '/',
                      state: { prevLocation: window.location.pathname },
                    }}
                  />
                )
              }

              return <Component {...props} />
            }

            if (props.location) {
              let redirObj
              let gameId = null
              let entryId = props.match.params.entryId

              switch (gameType) {
                case 'survivor':
                  gameId = props.match.params.survivorId
                  break
                case 'bracket':
                  gameId = props.match.params.bracketId
                  break
                case 'quiniela':
                  gameId = props.match.params.poolId
                  break
                case 'quinielaGrupo':
                  gameId = props.match.params.poolGroupId
                  break
                default:
                  break
              }

              redirObj = { id: gameId, game_type: gameType, entry_id: entryId }

              if (redirObj.id || redirObj.gameType) {
                utils.saveDataNotLoggedUser(redirObj)
              } else {
                console.error('not a game url')
              }
            }

            const returnPath = getFullReturnPath(props.location)
            return <Redirect to={buildLoginPath(returnPath)} />
          }}
        />
      )}
    </AuthContext.Consumer>
  )
}

export default PrivateRoute
